
export enum Gender {
    Female = 2,
    Male   = 1
}
